import {createSelector} from '@store/@common';

import JobStore from './JobStore';

const jobBase = createSelector(JobStore);

export const jobs = createSelector([jobBase], s => s.jobs);
